import { put, select } from 'redux-saga/effects';

import * as types from './meeting-archives.types';
import * as actions from './meeting-archives.actions';
import { meetingArchiveSelectors } from './meeting-archives.selectors';

export function* storeMeetingArchive(meetingArchive: types.IMeetingArchive) {
  yield put(actions.storeMeetingArchive(meetingArchive));
  return meetingArchive;
}

export function* clearMeetingArchive(meetingArchiveId: types.IMeetingArchive['id']) {
  yield put(actions.clearMeetingArchive(meetingArchiveId));
}

export function* clearAllMeetingArchives() {
  const meetingArchiveIds: types.IMeetingArchive['id'][] = yield select(meetingArchiveSelectors.selectResourceIds);
  yield put(actions.clearMeetingArchive(meetingArchiveIds));
}
